import { render, staticRenderFns } from "./LinkToLogin.vue?vue&type=template&id=42ea5b6e&scoped=true&"
import script from "./LinkToLogin.vue?vue&type=script&lang=js&"
export * from "./LinkToLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ea5b6e",
  null
  
)

export default component.exports